import React, { Fragment, useState, useEffect } from 'react';


// Styles
import './sass/main.scss';


// Components
import Formulario from './components/Formulario';
import Cita from './components/Cita';





const App = () => {
    //Citas en localStorage
    let citasLocalStorage = JSON.parse(localStorage.getItem('citas'));
    if(!citasLocalStorage) {
        citasLocalStorage = [];
    }


    //Crear el state de las citas
    const [ citas, setCitas ] = useState(citasLocalStorage);

    // funcion que tome las citas actuales y tome la nueva
    const newCita = data => {
        setCitas([
            ...citas,
            data
        ])
    }

    //useEffect para guardar en localStorage
    //Siempre es un arrow function
    useEffect( () => {
        let citasLocalStorage = JSON.parse(localStorage.getItem('citas'));

        if(citasLocalStorage) {
            localStorage.setItem('citas', JSON.stringify(citas))
        } else {
            localStorage.setItem('citas', JSON.stringify([]))
        }

        //para ejecutar el useEfect solo una vez se le pasa un arreglo vacio
        //Array de dependencias
    }, [citas] )



    // funcion para eliminar una cita por su id
    const deleteMeeting = id => {
        const currentCita = citas.filter(item => (item.id !== id))

        //No se pone entre [] ya que .filter devuelve un nuevo arreglo
        setCitas(currentCita)
    }

    //mensaje condsicional
    const message = citas.length === 0
        ? 'No hay citas por administrar'
        : 'Administra tus citas';

    return (
        <Fragment>
            <h1>Administrador de pacientes</h1>

            <div className="grapper">
                <div className="meeting">
                    <div className="meeting__content">
                        <Formulario newCita={newCita} />
                    </div>

                    <div className="meeting__content">
                        <h2>{ message }</h2>
                        {citas.map(cita => (
                            <Cita
                                key={cita.id}
                                cita={cita}
                                deleteMeeting={deleteMeeting} />
                        ))}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default App;
